export default "__VITE_ASSET__DcoZLIpX__"